<template>
	<div class="spinner">
		<div class="spinner-1"></div>
		<div class="spinner-2"></div>
		<div class="spinner-3"></div>
	</div>
</template>

<script>
	export default {
		name: 'LoadingSpinner',
	};
</script>

<style lang="scss" scoped>
	$spinner-color: #f50057;
	$spinner-size: 1;
	$faded-opacity: 0.35;
	$spinner-delay: 0.18;
	$spinner-scale: 0.87;
	$animation-duration: 1.1s;
	$animation-rest: 25;

	.wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}

	.spinner {
		& * {
			display: inline-block;
			width: #{$spinner-size}rem;
			height: #{$spinner-size}rem;
			background-color: $spinner-color;
			border-radius: #{$spinner-size}rem;
			margin: 0 #{$spinner-size / 5}rem;
		}

		@for $i from 1 through 3 {
			& .spinner-#{$i} {
				animation: fade $animation-duration ease-in-out #{$i * $spinner-delay}s infinite both;
			}
		}
	}

	@keyframes fade {
		0% {
			opacity: $faded-opacity;
			transform: scale($spinner-scale);
		}
		#{(100 - $animation-rest) / 2}% {
			opacity: 1;
			transform: scale(1);
		}
		#{100 - $animation-rest}% {
			opacity: $faded-opacity;
			transform: scale($spinner-scale);
		}
		100% {
			opacity: $faded-opacity;
			transform: scale($spinner-scale);
		}
	}
</style>
